// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 8 7", width: "8", height: "7" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", null,
                React.createElement("path", { d: "M888.758248,315 L883,315 L883,314 L888.758608,314 L887.001488,312.224708 L887.530665,311 L891,314.500167 L887.530334,318 L887,316.773958 L888.758248,315 Z M889,314.756088 L889.253655,314.500167 L889,314.243889 L889,314.756088 Z", transform: "translate(-883 -311)" })))));
};
Icon.displayName = 'ArrowRight8x7';
export default Icon;
//# sourceMappingURL=ArrowRight8x7.js.map